<template>
    <dv-border-box-12>
        <div id="alarm-chart-container" style="width:100%; height:100%;"></div>
    </dv-border-box-12>
</template>

<script>
/* eslint-disable */

import * as echarts from "echarts";

export default {
    name: "AlarmChart",
    data() {
        return {
            chartData: [],
        };
    },
    mounted() {
      this.$api.getAlarmTotal().then((res) => {
        if (!res.ok) return
        this.chartData = res.data.map(function (x) {
            return {
            name: x.alarmTypeName,
            value: x.count
            }
        })
        console.debug('data', JSON.stringify(this.chartData))
        this.drawLine()
      }).catch((error) => {
        console.log(error)
      })
    },
    methods: {
        drawLine() {
            // 基于准备好的dom，初始化echarts实例
            let myChart = echarts.init(
                document.getElementById("alarm-chart-container")
            );
            // 绘制图表
            myChart.setOption({
                color: ["#5470c6", "#91cc75", "#fac858", "#ee6666", "#73c0de"],
                backgroundColor: "transparent",
                title: {
                    text: "预警统计",
                    //textAlign: "center",
                    textStyle: {
                        color: "#FFFFFF",
                        fontSize: "16px",
                    },
                },
                // legend: {
                //   orient: "vertical",
                //   //left: "left",
                //   bottom: "bottom"
                // },
                tooltip: {
                    trigger: "item",
                },
                series: [
                    {
                        name: "预警统计",
                        type: "pie",
                        radius: "72%",
                        data: this.chartData,
                        label: {
                            textStyle: {
                                color: "rgba(255,255,255,.5)",
                                fontSize: 12,
                                fontWeight: "bolder",
                            },
                        },
                    },
                ],
            });
        },
    },
};
</script>

<style lang="less"></style>
